import React, { useEffect } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import products from './products';
import ProductPage from './ProductPage';
import Privacy from './Privacy';
import Terms from './Terms';
import About from './About';
import Donate from './Donate';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<MainLayout><Home /></MainLayout>} />
        <Route path="/product/:id" element={<MainLayout><ProductPage /></MainLayout>} />
        <Route path="/privacy" element={<MainLayout><Privacy /></MainLayout>} />
        <Route path="/terms" element={<MainLayout><Terms /></MainLayout>} />
        <Route path="/about" element={<MainLayout><About /></MainLayout>} />
        <Route path="/donate" element={<MainLayout><Donate /></MainLayout>} />
      </Routes>
    </>
  );
}

function MainLayout({ children }) {
  return (
    <div className="App">
      <header className="App-header">
        <img src={process.env.PUBLIC_URL + '/Graphics/Logo/NeuLogic.png'} className="brand-logo" alt="NeuLogic Logo" style={{cursor:'pointer'}} onClick={() => window.location.href = '/'} />
        {/* Subtitle will get a class based on location */}
        <RouteSubtitle />
        {children}
      </header>
      <footer className="footer">
        <FooterLinks />
      </footer>
    </div>
  );
}

function RouteSubtitle() {
  const location = useLocation();
  if (location.pathname === '/')
    return <h2 className="subtitle home-subtitle">{'Tools Built from Experience'}</h2>;
  if (location.pathname.startsWith('/product'))
    return <h2 className="subtitle product-subtitle">{''}</h2>;
  return null;
}

function FooterLinks() {
  const links = [
    { label: 'Contact', href: 'mailto:support@neulogic.tech' },
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'About', href: '/about' },
    { label: 'Donate', href: '/donate' }
  ];
  return (
    <nav style={{display:'flex',justifyContent:'center',alignItems:'center',gap:'1.5rem'}}>
      {links.map((link, idx) => (
        <React.Fragment key={link.label}>
          <a href={link.href} className="footer-link">{link.label}</a>
          {idx < links.length - 1 && <span className="footer-divider">|</span>}
        </React.Fragment>
      ))}
    </nav>
  );
}

function Home() {
  return (
    <div className="card-grid">
      {products.map(product => (
        <Link
          to={`/product/${product.id}`}
          key={product.id}
          className="product-card"
          style={{ textDecoration: 'none', position: 'relative' }}
        >
          {product.price === 0 && (
            <div className="free-ribbon"><span>FREE SOFTWARE</span></div>
          )}
          <div className="card-image-wrapper">
            <img src={product.heroImage} alt={product.name} className="card-image" />
          </div>
          <div className={`card-title${product.name === 'Text Color Visualizer' ? ' card-title-nowrap' : ''}`}>{product.name}</div>
          <div className="card-desc">{product.shortDesc}</div>
        </Link>
      ))}
    </div>
  );
}

export default App;